<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Other Charge</v-toolbar-title>

		    <!-- <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			
			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->
			
			<v-layout wrap padding-top-bottom-ten white-background>

				<v-flex xs12 sm12 md12 form-item>
	               <v-text-field  v-model="Form.name" label="Name" placeholder=" " v-validate="'required|max:50'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
	            </v-flex>
	            <v-flex xs12 sm12 md12 form-item v-if="false">
	               <v-text-field  v-model="Form.shortName" placeholder=" " label="Short Name"></v-text-field>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item>
	               	<v-radio-group v-model="Form.mode" row>
				      <v-radio label="Percentage" :value="0"></v-radio>
				      <v-radio label="Value" :value="1"></v-radio>
				    </v-radio-group>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item>
	               	<v-radio-group v-model="Form.nature" row>
				      <v-radio label="(+)" :value="0"></v-radio>
				      <v-radio label="(-)" :value="1"></v-radio>
				    </v-radio-group>
	            </v-flex>

            	<v-flex xs12 sm12 md12 form-item>
	               <v-checkbox class="check_box" label="Adjust In Sale" v-model="Form.adjustInSale"></v-checkbox>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item 
	            	v-if="!Form.adjustInSale" 
	            	@click="fn_openAccountLedgers('android', 'SaleAccountLedger', 'field_saleAccountLedger')">

	               <v-text-field  
		               	readonly 
		               	v-model="Form.saleAccountItemName" 
		               	label="Ledger" 
		               	placeholder=" " 
		               	append-icon="arrow_drop_down"
		               	ref="field_saleAccountLedger" 
		               	:onUpdate="fn_updateSaleAccountLedger" 
		               	v-validate="'required'" 
		               	:error-messages="errors.collect('sale account ledger')" 
		               	data-vv-name="sale account ledger" 
		               	required>
	               </v-text-field>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item>
	               <v-checkbox class="check_box" label="Adjust In Purchase" v-model="Form.adjustInPurchase"></v-checkbox>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item 
	            	v-if="!Form.adjustInPurchase" 
	            	@click="fn_openAccountLedgers('android', 'PurchaseAccountLedger', 'field_purchaseAccountLedger')">

	            	<v-text-field  
		               	readonly 
		               	v-model="Form.purchaseAccountItemName" 
		               	label="Ledger" 
		               	placeholder=" " 
		               	append-icon="arrow_drop_down"
		               	ref="field_purchaseAccountLedger" 
		               	:onUpdate="fn_updatePurchaseAccountLedger" 
		               	v-validate="'required'" 
		               	:error-messages="errors.collect('purchase account ledger')" 
		               	data-vv-name="purchase account ledger" 
		               	required>
	               	</v-text-field>
	               	
	            </v-flex>
			    
			</v-layout>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>
		</v-form>

	    <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>
		<dialog-parties ref="ref_dialogLedger" :newParty="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-parties>

	    <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	</div>
</template>

<script>
const dialogjs =  require('../dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;

import dialogDiscard from '../../../dialogs/dialog_discard'
import dialogParties from '../../../dialogs/dialog_parties'

import {draftMixin} from '../../../draft_mixin'
// import dialogDraftItems from '../../../dialogs/dialog_draft_items'

	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:{"addOnsId":null,"name":null, "shortName":null, "addonGroupId":3, "systemDefined":0, "versionId":"1", "status":"1", "adjustInSale":true, "saleAccountItemId":null, "saleAccountItemName":null, "purchaseAccountItemId":null, "adjustInPurchase":true, "purchaseAccountItemName":null, "nature":0, "mode":1, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null, "isNew":true},
				loading:false,
				tagId:null,
				dialogStorageId:null,
				draftStorageId:null,
				backButtonPress:false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				// loadedFromDraft:false,
				ledgerType:null
			}
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                    // this.fn_saveToLocalStorage(this)
                    if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                },
                deep: true
            }
		},
		components:{
			'dialog-discard': dialogDiscard,
			'dialog-parties':dialogParties
			// 'dialog-draft-items': dialogDraftItems
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				this.$refs[ref].openDialogWeb();
			},

			// fn_openAccountLedgers: function (platform, name, ref) {

			// 	let viewDialogObject = { ToolbarTitle:"Ledger", groupTypeId:103, action:"new", accountGroups:null, accountGstTypes:null };
			// 	viewDialogObject.ToolbarTitle = "Ledger";
			// 	viewDialogObject.selectedItem = null;
			// 	viewDialogObject.ref = ref;

			// 	if(name=='SaleAccountLedger'){
			// 		if(this.Form.saleAccountItemId && this.Form.saleAccountItemName){
			// 			viewDialogObject.selectedItem = {"itemId":this.Form.saleAccountItemId, "itemName":this.Form.saleAccountItemName};
			// 		}
			// 		this.ledgerType = 'sale';
			// 	}
			// 	else if(name=='PurchaseAccountLedger'){
			// 		if(this.Form.purchaseAccountItemId && this.Form.purchaseAccountItemName){
			// 			viewDialogObject.selectedItem = {"itemId":this.Form.purchaseAccountItemId, "itemName":this.Form.purchaseAccountItemName};
			// 		}
			// 		this.ledgerType = 'purchase';
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.$nextTick(() => {
			// 		this.fn_openDialogWeb('web', 'Ledger', 'ref_dialogLedger');
			// 	})
			// },
			
			fn_openAccountLedgers: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Ledger";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.groupTypeId = 103;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(name=='SaleAccountLedger'){
					if(this.Form.saleAccountItemId && this.Form.saleAccountItemName){
						paramObject.defaultValue = {"id":this.Form.saleAccountItemId, "name":this.Form.saleAccountItemName};
					}
					this.ledgerType = 'sale';
				}
				else if(name=='PurchaseAccountLedger'){
					if(this.Form.purchaseAccountItemId && this.Form.purchaseAccountItemName){
						paramObject.defaultValue = {"id":this.Form.purchaseAccountItemId, "name":this.Form.purchaseAccountItemName};
					}
					this.ledgerType = 'purchase';
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			fn_updateSaleAccountLedger: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.saleAccountItemId = selectedValueId;
		        	this.Form.saleAccountItemName = selectedValueName;
		        	this.errors.remove('sale account ledger');
				}
				else{
					this.Form.saleAccountItemId = null;
		        	this.Form.saleAccountItemName = null;
				}
				this.$forceUpdate();
				this.fn_saveDraft(this.Form.name);
			},

			fn_updatePurchaseAccountLedger: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.purchaseAccountItemId = selectedValueId;
		        	this.Form.purchaseAccountItemName = selectedValueName;
		        	this.errors.remove('purchase account ledger');
				}
				else{
					this.Form.purchaseAccountItemId = null;
		        	this.Form.purchaseAccountItemName = null;
				}
				this.$forceUpdate();
				this.fn_saveDraft(this.Form.name);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				var self = this;
			      this.$validator.validateAll().then((result) => {
			        if (result) {
			           self.fn_post();
			          	return; 
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('AddOns', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	// self.snackbar = true;
				          	// self.snackbar_msg = "Already exists with this name";
				          	self.showToast("Already exists with this name");
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};
					data.type = 'otherCharges';
					data.id = this.Form.addOnsId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("master_items_state")){
						let obj = JSON.parse(localStorage.getItem("master_items_state"));
						obj.itemId = self.Form.addOnsId;
						localStorage.setItem("master_items_state",JSON.stringify(obj));
					}

					self.$router.go(-1);
				});
			},

			fn_post: function(){
				// !this.Form.addOnsId ? this.Form.addOnsId = this.guid() : '';
				if(!this.Form.addOnsId){
					this.Form.addOnsId = this.guid();
					// this.Form.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();
				
				this.Form.name = this.Form.name.trim();
				
				if(this.Form.adjustInSale){
					this.Form.saleAccountItemId = null;
		        	this.Form.saleAccountItemName = null;
				}
				if(this.Form.adjustInPurchase){
					this.Form.purchaseAccountItemId = null;
		        	this.Form.purchaseAccountItemName = null;
				}
				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_get: function(itemId, copyData){
				var self = this;
				this.unwatch = true;
				this.Form.isNew = false
				this.getData('AddOns', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.unwatch = true;
					        self.Form = JSON.parse(response);
					        self.Form.shortName == 'null' ? self.Form.shortName = null : '';

					        if(copyData){
					          	self.Form.addOnsId=null;
					          	self.Form.isSystem = 0;
					   //        	self.snackbar = true;
								// self.snackbar_msg = "Data copied."
								self.showToast("Other Charges copied");
					        }

					        self.$root.fn_copyFormObject(self.Form, self.formId);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_clearForm: function(){
				this.Form = {"addOnsId":null,"name":null, "shortName":null, "addonGroupId":3, "systemDefined":0, "versionId":"1", "status":"1", "adjustInSale":true, "saleAccountItemId":null, "saleAccountItemName":null, "purchaseAccountItemId":null, "adjustInPurchase":true, "purchaseAccountItemName":null, "nature":0, "mode":1, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null, "isNew":true},
				this.baseUnitName = null;
				this.$validator.reset();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), ls:1, type:this.ledgerType, groupTypeId:103}})
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;

				if(this.Form.addOnsId){
					this.fn_get(this.Form.addOnsId);
				}
				else{
					this.fn_clearForm();
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					console.log("draft deleted");
					// self.showToast("Item deleted from draft");
				});
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Other Charges";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "sale":
					    	this.fn_updateSaleAccountLedger(itemData.id, itemData.name, false);
					        break;
					    case "purchase":
					    	this.fn_updatePurchaseAccountLedger(itemData.id, itemData.name, false);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			var formsArray = [];
			if(localStorage.getItem('otherchargesforms')){
				formsArray = JSON.parse(localStorage.getItem('otherchargesforms'));
			}
			formsArray.push(this.formId);
			localStorage.setItem('otherchargesforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

					// self.$route.query.tagId ? self.fn_checkDraftItems('Other Charges', true) : '';

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			// this.fn_setDraftData('Master', 'Other Charges');
			this.fn_setDraftData('temp', 'Other Charges');
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){
					itemId = from.params.tagId;  			
		  		}

		  		//edit from list view
		  		else if(from.name=='otherChargesItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'otherChargesItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'otherChargesDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}

		  		
		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData);
		  		// 	}
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData);
	  			}

		  	})
		},
		beforeRouteUpdate (to, from, next) {
			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('otherchargesforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					// this.$root.fn_deleteFormObject();
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('otherchargesforms', function(){
						next();
					})
				}
				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	localStorage.removeItem('otherchargesforms')
				// 	next();	
				// }
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/other_charges/form.vue